<div class="fullScreenCenterCenter">
    <div class="w300px">

        <!-- Form inicio sesion instructor -->
        <h6 class="ft16 ft500 centertext">Inicio de sesión para instructores</h6>
        <div class="mgt20">
            <input type="text" class="fw" placeholder="Correo" #userName required>
        </div>

        <div class="mgt10">
            <input type="password" class="fw" placeholder="Contraseña" #userPassword required>
        </div>

        <div>
            <button class="mgt10 darkButton fw" (click)="authService.SignInInstructor(userName.value, userPassword.value)">
                Iniciar sesión
            </button>
        </div>

    </div>
</div>